import styled from 'styled-components';

export const StyledForm =styled.form`
  display: flex;
  flex-direction: column;
  gap: 5px;
  width: 100%;
  align-items: flex-start;
`
export const StyledFormLabel =styled.span`
  font-size: 16px;
  margin: 5px 0;
  color: black;
`
export const StyledError = styled.span((p) => `
    color: red;
    margin-left: 5px;
`);

export const StyledLabeledFieldContainer = styled.div`
    display: flex;
    flex-direction: column;
    width: 100%;
    position: relative;
`;
